import {toast, ToastCard} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import type {FC} from 'react';

export type PaymentReceivedToastProps = {
  toastId: string | number;
  name: string;
  amount: string;
  dateTime: string;
  onNavigate: () => void;
};

export const PaymentReceivedToast: FC<PaymentReceivedToastProps> = ({
  toastId,
  name,
  amount,
  dateTime,
  onNavigate
}) => {
  const {t} = useTranslation('payments');

  return (
    <ToastCard
      iconName="sollapay:check"
      title={t('paymentReceivedToast.title')}
      description={t('paymentReceivedToast.description', {name, amount, dateTime})}
      action={{label: t('paymentReceivedToast.actionLabel'), onClick: onNavigate}}
      onClose={() => toast.dismiss(toastId)}
      closeLabel={t('paymentReceivedToast.close')}
    />
  );
};

export function showPaymentReceivedToast(
  name: string,
  amount: string,
  dateTime: string,
  onNavigate: () => void
): void {
  toast.custom(
    id => (
      <PaymentReceivedToast
        toastId={id}
        name={name}
        amount={amount}
        dateTime={dateTime}
        onNavigate={onNavigate}
      />
    ),
    {
      duration: 30_000
    }
  );
}
